import { api } from '@ohif/core';

export async function getStudyInstanceAPI() {
  // The api instance's request interceptor attaches Authorization/x-api-key
  // from storage automatically, so no manual token/header handling is needed here.
  const path = '/viewers/ohif';

  try {
    const response = await api.get(path);
    console.log('Study info:', response.data);

    // Note: The segmentation loaded state is now managed by SegmentationStateProvider
    // instead of localStorage. Initialize it to false on app start.
    // The provider will update this state when a segmentation is actually loaded.

    return response.data;
  } catch (error) {
    console.error('Error fetching study info:', error);
  }
}
